const API_VERSION = 'v1';
const API_ORIGIN = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

if (!API_ORIGIN) {
  throw new Error('VITE_API_URL is required. Copy .env.example to .env and set the Laravel API origin.');
}

const API_BASE = `${API_ORIGIN}/api/${API_VERSION}`;
export const tokenKey = 'lehaq-auth-token-v1';

export class ApiError extends Error {
  constructor(message, status, details) { super(message); this.name = 'ApiError'; this.status = status; this.details = details; }
}

export async function api(path, options = {}) {
  const token = localStorage.getItem(tokenKey);
  const response = await fetch(`${API_BASE}${path}`, { ...options, headers: { Accept: 'application/json', ...(token ? {Authorization:`Bearer ${token}`} : {}), ...options.headers } });
  const payload = await response.json().catch(() => ({}));
  if (response.status === 401 && token) {
    localStorage.removeItem(tokenKey);
    window.dispatchEvent(new CustomEvent('lehaq:session-expired'));
    throw new ApiError('Your session expired. Please sign in again.', 401, payload.errors);
  }
  if (!response.ok) throw new ApiError(payload.message || 'Request failed', response.status, payload.errors);
  return payload;
}

export function jsonOptions(method, body) { return {method, headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)}; }
export const apiUrl = path => `${API_BASE}${path}`;
